import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import shortid from "shortid";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import Button from "@mui/material/Button";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import Select from "@mui/material/Select";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";

import "../../assets/css/utility/input-field.css";
import "../../assets/css/utility/user-card.css";
import "../../assets/css/load-list-page.css";
import "../../assets/css/loads-list-search-page.css";
import LoaderImg from "../../assets/media/loader.gif";

import MenuItem from "@mui/material/MenuItem";
import {
  COUNTRY_STATE_N_CITY_LIST_URL,
  CARRIER_LIST_URL,
} from "../../utils/api-ends";

import useHttp from "../../hooks/useHttp";
import Rating from "../../components/Rating";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

const SearchCarrier = () => {
  const [openSearchBox, setOpenSearchBox] = useState(true);
  const [carrierValues, setCarrierValues] = useState({
    country: "",
    state: "",
    city: "",
    rating: "",
    load_type: "",
    name: "",
    nextPageNumber: "",
  });
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [carrierList, setCarrierList] = useState([]);
  const { isLoading, sendRequests } = useHttp();
  const {
    isLoading: isLoadingMoreCarrier,
    sendRequests: loadMoreCarrierRequest,
  } = useHttp();
  let { pathname } = useLocation();

  const cleanData = () => {
    setCarrierValues({
      country: "",
      state: "",
      city: "",
      rating: "",
      load_type: "",
      name: "",
      nextPageNumber: "",
    });
  };

  useEffect(() => {
    // set state list values in state
    const response = (data) => {
      setCarrierList(data.results);
      const inputValue = {
        ...carrierValues,
        nextPageNumber: data.pagination.next_page_number,
      };
      setCarrierValues(inputValue);
    };
    // Send request to get state list
    sendRequests(
      {
        url: CARRIER_LIST_URL(),
        method: "GET",
      },
      response
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendRequests]); // No `carrierValues` in dependencies to avoid infinite re-renders

  // Fetch list of country
  useEffect(() => {
    const response = (data) => {
      setCountryList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "countries",
        },
      },
      response
    );
  }, [sendRequests]);

  // // Fetch list of state
  useEffect(() => {
    const response = (data) => {
      setStateList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "states",
          country_name: carrierValues.country,
        },
      },
      response
    );
  }, [carrierValues.country, sendRequests]);

  // Fetch list of city
  useEffect(() => {
    const response = (data) => {
      setCityList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "cities",
          country_name: carrierValues.country,
          state_name: carrierValues.state,
        },
      },
      response
    );
  }, [carrierValues.country, carrierValues.state, sendRequests]);

  //Update state values when input values change.
  const handleInputChange = (e) => {
    const inputValue = {
      ...carrierValues,
      [e.target.name]: e.target.value,
      nextPageNumber: 2,
    };
    setCarrierValues(inputValue);
  };

  //Update state value when click on search button
  const searchByName = (e) => {
    const nameValue = document.getElementById("user-name-search-input").value;
    const inputValue = { ...carrierValues, name: nameValue, nextPageNumber: 2 };
    setCarrierValues(inputValue);
  };

  useEffect(() => {
    const response = (data) => {
      setCarrierList(data.results);
    };

    sendRequests(
      {
        url: CARRIER_LIST_URL(
          carrierValues.state,
          carrierValues.city,
          carrierValues.rating,
          carrierValues.load_type,
          carrierValues.name
        ),
        method: "GET",
      },
      response
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    carrierValues.state,
    carrierValues.city,
    carrierValues.rating,
    carrierValues.load_type,
    carrierValues.name,
  ]);

  //Scroll Pagination
  window.onscroll = function (ev) {
    //Check if scroll to the bottom
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight &&
      pathname === "/search-carrier" &&
      carrierValues.nextPageNumber
    ) {
      const response = (data) => {
        // Update the carrerList state
        setCarrierList([...carrierList, ...data.results]);
        const pageNumber =
          data.pagination.next_page_number != null
            ? data.pagination.next_page_number
            : "";
        setCarrierValues({ ...carrierValues, nextPageNumber: pageNumber });
      };

      // Send get request to get carrier list
      loadMoreCarrierRequest(
        {
          url: CARRIER_LIST_URL(
            carrierValues.state,
            carrierValues.city,
            carrierValues.rating,
            carrierValues.load_type,
            carrierValues.name,
            carrierValues.nextPageNumber
          ),
          method: "GET",
        },
        response
      );
    }
  };

  return (
    <>
      <section className="search-options-load-list">
        <Accordion className="load-post-search-box-wrapper">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-lg-8 col-sm-10 col-9">
                <div className="user-name-search-box">
                  <input
                    placeholder="Search Carrier"
                    name="name"
                    id="user-name-search-input"
                  />
                  <Button onClick={searchByName}>
                    <SearchIcon />
                  </Button>
                </div>
              </div>

              <div className="col-lg-4 col-2">
                <div className="multiple-btn flex-direction-initial search-user-button">
                  <AccordionSummary className="p-0">
                    <button
                      className={`m-0 ${
                        !openSearchBox && "searh-box-close-button"
                      }`}
                      onClick={() => setOpenSearchBox(!openSearchBox)}
                    >
                      {openSearchBox ? <FilterListIcon /> : <CloseIcon />}
                      <span>{openSearchBox ? "Filter" : "Close"}</span>
                    </button>
                  </AccordionSummary>
                </div>
              </div>
            </div>
          </div>

          <AccordionDetails>
            <div className="container theme-section">
              <div className="row">
                <div className="col-xl-3 col-md-6">
                  <div className="input-box-area" single-labe="true">
                    <label> Country</label>
                    <div>
                      <Select
                        label={"Country"}
                        name="country"
                        className="input-box-area-select-field mui-select-field-without-label"
                        id="state-input-field"
                        fullWidth
                        onChange={handleInputChange}
                        defaultValue={carrierValues.country}
                        inputProps={{
                          value: carrierValues.country,
                        }}
                        sx={{
                          "& .MuiSelect-iconOutlined": {
                            display: carrierValues.country ? "none" : "",
                          },
                          "&.Mui-focused .MuiIconButton-root": {
                            color: "primary.main",
                          },
                        }}
                        endAdornment={
                          <IconButton
                            sx={{
                              visibility: carrierValues.country
                                ? "visible"
                                : "hidden",
                            }}
                            onClick={() =>
                              setCarrierValues((prevS) => {
                                return {
                                  ...prevS,
                                  country: "",
                                };
                              })
                            }
                          >
                            <ClearIcon />
                          </IconButton>
                        }
                      >
                        {countryList?.map((country) => (
                          <MenuItem value={country} key={shortid.generate()}>
                            {country}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="input-box-area" single-labe="true">
                    <label> State</label>
                    <div>
                      <Select
                        label="State"
                        name="state"
                        className="input-box-area-select-field mui-select-field-without-label"
                        id="state-input-field"
                        fullWidth
                        onChange={handleInputChange}
                        defaultValue={carrierValues.state}
                        inputProps={{
                          value: carrierValues.state,
                        }}
                        sx={{
                          "& .MuiSelect-iconOutlined": {
                            display: carrierValues.state ? "none" : "",
                          },
                          "&.Mui-focused .MuiIconButton-root": {
                            color: "primary.main",
                          },
                        }}
                        endAdornment={
                          <IconButton
                            sx={{
                              visibility: carrierValues.state
                                ? "visible"
                                : "hidden",
                            }}
                            onClick={() =>
                              setCarrierValues((prevS) => {
                                return {
                                  ...prevS,
                                  state: "",
                                };
                              })
                            }
                          >
                            <ClearIcon />
                          </IconButton>
                        }
                      >
                        {stateList?.map((state) => (
                          <MenuItem value={state} key={shortid.generate()}>
                            {state}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="input-box-area" single-labe="true">
                    <label> City</label>
                    <div>
                      <Select
                        label="City"
                        name="city"
                        className="input-box-area-select-field mui-select-field-without-label"
                        fullWidth
                        onChange={handleInputChange}
                        defaultValue={carrierValues.city}
                        inputProps={{
                          value: carrierValues.city,
                        }}
                        sx={{
                          "& .MuiSelect-iconOutlined": {
                            display: carrierValues.city ? "none" : "",
                          },
                          "&.Mui-focused .MuiIconButton-root": {
                            color: "primary.main",
                          },
                        }}
                        endAdornment={
                          <IconButton
                            sx={{
                              visibility: carrierValues.city
                                ? "visible"
                                : "hidden",
                            }}
                            onClick={() =>
                              setCarrierValues((prevS) => {
                                return {
                                  ...prevS,
                                  city: "",
                                };
                              })
                            }
                          >
                            <ClearIcon />
                          </IconButton>
                        }
                      >
                        {cityList?.map((state, index) => (
                          <MenuItem value={state} key={shortid.generate()}>
                            {state}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="input-box-area" single-labe="true">
                    <label> Rating </label>
                    <div>
                      <Select
                        label="Rating"
                        name="rating"
                        className="input-box-area-select-field mui-select-field-without-label"
                        fullWidth
                        onChange={handleInputChange}
                        defaultValue={carrierValues.rating}
                        inputProps={{
                          value: carrierValues.rating,
                        }}
                        sx={{
                          "& .MuiSelect-iconOutlined": {
                            display: carrierValues.rating ? "none" : "",
                          },
                          "&.Mui-focused .MuiIconButton-root": {
                            color: "primary.main",
                          },
                        }}
                        endAdornment={
                          <IconButton
                            sx={{
                              visibility: carrierValues.rating
                                ? "visible"
                                : "hidden",
                            }}
                            onClick={() =>
                              setCarrierValues((prevS) => {
                                return {
                                  ...prevS,
                                  rating: "",
                                };
                              })
                            }
                          >
                            <ClearIcon />
                          </IconButton>
                        }
                      >
                        <MenuItem value="asc">ASC</MenuItem>
                        <MenuItem value="dsc">DESC</MenuItem>
                      </Select>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="input-box-area" single-labe="true">
                    <label> Load types </label>
                    <div>
                      <Select
                        label="Load type"
                        name="load_type"
                        className="input-box-area-select-field mui-select-field-without-label"
                        fullWidth
                        onChange={handleInputChange}
                        defaultValue={carrierValues.load_type}
                        inputProps={{
                          value: carrierValues.load_type,
                        }}
                        sx={{
                          "& .MuiSelect-iconOutlined": {
                            display: carrierValues.load_type ? "none" : "",
                          },
                          "&.Mui-focused .MuiIconButton-root": {
                            color: "primary.main",
                          },
                        }}
                        endAdornment={
                          <IconButton
                            sx={{
                              visibility: carrierValues.load_type
                                ? "visible"
                                : "hidden",
                            }}
                            onClick={() =>
                              setCarrierValues((prevS) => {
                                return {
                                  ...prevS,
                                  load_type: "",
                                };
                              })
                            }
                          >
                            <ClearIcon />
                          </IconButton>
                        }
                      >
                        <MenuItem value="vehicle">Vehicle</MenuItem>
                        <MenuItem value="pallet">Pallet</MenuItem>
                        <MenuItem value="barrel">Barrel</MenuItem>
                        <MenuItem value="stones">Stones</MenuItem>
                        <MenuItem value="sand">Sand</MenuItem>
                        <MenuItem value="laterite">Laterite</MenuItem>
                      </Select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="multiple-btn flex-direction-initial search-user-button">
                <AccordionSummary className="p-0">
                  <button
                    className={`m-0 searh-box-close-button`}
                    onClick={cleanData}
                  >
                    <CleaningServicesIcon />
                    <span>Clean</span>
                  </button>
                </AccordionSummary>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </section>

      <section id="load-list-users">
        <div className="container">
          <div className="row">
            {isLoading ? (
              <div className="loader d-flex justify-content-center mb-5 mt-5">
                <img style={{ width: "35px" }} src={LoaderImg} alt="" />
              </div>
            ) : (
              <>
                {carrierList?.map((value, index) => (
                  <div className="col-xl-4 col-md-6">
                    <div className="user-info-and-load-details-card">
                      <div className="loader-user-info mb-3">
                        <div className="loader-user-img">
                          <img src={value.profile_picture} alt="" />
                        </div>

                        <div>
                          <h1 className="large-text">{value.full_name}</h1>
                          <div className="user-rating">
                            <Rating rating={value.avg_review_rating} />
                            <span>
                              (
                              {value.avg_review_rating != null
                                ? value.avg_review_rating
                                : 0}
                              )
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="user-extra-info">
                        {/* {<h1 className="large-text"> Total Loads: Vehicle </h1>} */}
                        <div className="user-extra-info-box">
                          <span>Carrier Type:</span>
                          <span>{value.carrier_type_value}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Load Type:</span>
                          <span>{value.load_type_value}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Country:</span>
                          <span>{value.country}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>State/Region:</span>
                          <span>{value.state}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>City:</span>
                          <span>{value.city}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Zip Code:</span>
                          <span>{value.zip_code}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Address:</span>
                          <span>{value.street_address}</span>
                        </div>
                      </div>

                      <div className="multiple-btn mt-3">
                        <Link
                          to={`/${value.user_id}/user-profile-information/`}
                        >
                          Expand
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}

                {carrierList?.length === 0 && (
                  <div className="col-xl-12 col-md-12">
                    <div className="no-data-found">
                      <h1 className="large-text">No Data Found</h1>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>

          {isLoadingMoreCarrier && (
            <div className="loader d-flex justify-content-center mb-5 mt-5">
              <img style={{ width: "35px" }} src={LoaderImg} alt="" />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SearchCarrier;
